/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React, { useState } from "react";
import { Button, Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { isMobileOrTablet } from "../Utils";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index.js";
import htmlparser from "html-react-parser";
import "./headerNav.css";

const imgCDNURL = process.env.REACT_APP_CDN_URL;

export default function HeaderNav({ HeaderData, isMobile }) {
  const [navbar, setNavbar] = useState(false);
  const isMobileOrTabletDevice = isMobileOrTablet();

  let prevScrollPos = window.scrollY;

  window.onscroll = function () {
    const currentScrollPos = window.scrollY;
    const Navbar = document.getElementById("Navbar");

    if (currentScrollPos === 0) {
      Navbar.classList.remove("navbarTransition");
      setNavbar(false);
    } else {
      if (prevScrollPos > currentScrollPos) {
        // Perform your desired actions for scrolling up here
        setNavbar(true);
      } else if (prevScrollPos < currentScrollPos) {
        // Perform your desired actions for scrolling down here
        if (!isMobileOrTabletDevice) {
          setNavbar(true);
        } else {
          setNavbar(false);
          Navbar.classList.add("navbarTransition");
        }
      }
    }
    prevScrollPos = currentScrollPos;
  };

  const handleMenuClick = () => {
    setNavbar(true);
  };
  
  function scrollToSection() {
    const isDesktop = window.matchMedia("(min-width: 319px)").matches; // Check if the screen width is greater than or equal to 1024px (adjust this value as needed)
    const navbarHeight = document.querySelector('nav').offsetHeight; // Get the height of the navigation bar
    const offset = 10; // Adjust this value to determine how much above the form the scroll will stop
    const sectionPosition = document.getElementById("Connect-With-Us").offsetTop - (isDesktop ? (navbarHeight + offset) : 0); // Adjust scroll position only for desktop
    
    // Hide expanded navbar options
    // document.getElementById("responsive-navbar-nav").classList.remove("show");
    
    window.scrollTo({
        top: sectionPosition,
        behavior: "smooth",
    });
    setNavbar(false);
}

  return (
    <>
      <div>
        <Navbar
          id="Navbar"
          collapseOnSelect
          expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          className={navbar ? "navbar active" : "navbar"}
        >
          <Container>
            <Navbar.Brand className="d-flex logo-align">
              <a href="https://www.swmc.com">
                <img
                  src={"https://d2w24n4g34usfg.cloudfront.net/wholesale-websites/SunWest-Logo.png"}
                  alt="SWMC Logo"
                  height="auto"
                  width="auto"
                  className="main_logo"
                />
              </a>
              <a href="https://www.angelai.com">
                <img
                  src={"https://resources.swmc.com/angel-ai/angelai-brandlogo.webp"}
                  alt="AngelAi Logo"
                  height="auto"
                  width="auto"
                  className="angelai_logo"
                />
              </a>
              {!isMobile && (
                <div className="desktopacesibity">
                <UserWayAccessibilityMenu color="black" width={30} height={30} />
                </div>
              )}
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav>
                <Nav.Link href="tel:+1-8556279378" onClick={handleMenuClick} className="callSWMC">
                  {htmlparser(HeaderData.About)}
                </Nav.Link>
                <Nav.Link href="#Connect-With-Us" onClick={handleMenuClick} className="ConnectWithUs">
                  {htmlparser(HeaderData.Contact)}
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <div className="mobileaccesibity">
                <UserWayAccessibilityMenu color="white" width={30} height={30} />
                </div>
      </div>
    </>
  );
}
